import React from "react"
import styled from "styled-components"
import Isvg from "react-inlinesvg"
import { Colors } from "styles/app-styles"
import { InfoIcon } from "images/icons/header"

export const ReadOnly_s = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 140px;
  color: ${Colors.denim};
  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
`

const ReadOnly = () => {
  return (
    <ReadOnly_s>
      <span>{"Read-Only Mode"}</span>
      <Isvg src={InfoIcon} title="You are in Read-Only mode as this organization does not have an active rDCF subscription. Please enter a support ticket to receive information about our subscription plans." />
    </ReadOnly_s>
  )
}

export default ReadOnly
